import { EntityType } from "../@core/entityType";
import { Operation } from "reactcoregk";

export const entityType = EntityType.SupportTicket;
export const entityOperations = [
  Operation.getAllPageable,
  Operation.create,
  Operation.get,
  Operation.update,
  Operation.delete,
];
